import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTailsComponent } from './simple-icons-tails.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTailsComponent ],
    exports:      [ SimpleIconsTailsComponent ],
    bootstrap:    []
})
export class SimpleIconsTailsModule {}
